// 获取小数位数
import {
  firstLetterUpperCase,
  getNodeById
} from "@/components/common/controlBar/controlBarDialog/metaComponent/worker.js";
import {
  modifyValueByCustomName,
  walkNode
} from "@/components/common/controlBar/controlBarDialog/metaComponent/utils.js";

function toInteger(floatNum) {
  if (Math.floor(floatNum) === floatNum) {
    return { times: 1, num: floatNum }
  }
  const str = `${floatNum}`
  const dotPos = str.indexOf('.')
  const len = str.substr(dotPos + 1).length
  const times = Math.pow(10, len)
  const intNum = Math.round(floatNum * times)
  return { times, num: intNum }
}
function operation(a, b, op, n) {
  const o1 = toInteger(a)
  const o2 = toInteger(b)
  const t1 = o1.times
  const t2 = o2.times
  const max = Math.max(t1, t2)
  let result = 0
  switch (op) {
    case 'add':
      result = (o1.num * (max / t1) + o2.num * (max / t2)) / max
      break
    case 'subtract':
      result = (o1.num * (max / t1) - o2.num * (max / t2)) / max
      break
    case 'multiply':
      result = (o1.num * o2.num) / (t1 * t2)
      break
    case 'divide':
      result = (o1.num / o2.num) * (t2 / t1)
      break
  }

  if (n || n === 0) return parseFloat(result.toFixed(n))
  return result
}

// 加
export function add (a, b, n = null) {
  return operation(a, b, 'add', n)
}
// 减
export function subtract (a, b, n = null) {
  return operation(a, b, 'subtract', n)
}
// 乘
export function multiply (a, b, n = null) {
  return operation(a, b, 'multiply', n)
}
// 除
export function divide (a, b, n = null) {
  return operation(a, b, 'divide', n)
}

// 数字转文字，1000以内
export function rolColNumber(num) {
  if (num < 1 || num > 999) {
    return '数字超出范围'
  }

  const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']

  if (num < 10) {
    return digits[num].replace('二', '两')
  }

  let result = ''
  const hundreds = Math.floor(num / 100)
  const tens = Math.floor((num % 100) / 10)
  const ones = num % 10

  if (hundreds > 0) {
    result += digits[hundreds] + '百'
  }

  if (tens > 0) {
    if (tens === 1 && hundreds === 0) {
      result += '十'
    } else {
      result += digits[tens] + '十'
    }
  } else if (hundreds > 0 && ones > 0) {
    result += '零'
  }

  if (ones > 0) {
    result += digits[ones]
  }

  return result
}

function diffAssemblyNode(assembleNode){
  walkNode(assembleNode, (walkedNode) => {
    diffSingleNodeDesignAndHover(walkedNode)
  })
}

export function diffSingleNodeDesignAndHover(node){
  if(node.data && node.data.design && node.data.hover){
    for(var customName in node.data.design){
      var [element, valueName] = customName.split('_')
      var hoverCustomName = element + '_hover' + firstLetterUpperCase(valueName)

      if(node.data.design[customName] && node.data.hover[hoverCustomName]){
        if(node.data.design[customName].diannao !== node.data.hover[hoverCustomName].diannao){

          console.log('=====different=====', {
            id: node.id,
            flag: node.flag,
            design: customName,
            hover: hoverCustomName
          })
        }
      }
    }
  }
}
window.diffSingleNodeDesignAndHover = diffSingleNodeDesignAndHover
window.diffAssemblyNode = diffAssemblyNode
